<template>
  <tr class="tr-values vs-table--tr tr-table-state-null">
      <slot></slot>
  </tr>
</template>

<script>
export default {
    name:'qb-tr'
}
</script>

<style>

</style>